import { createContext, useContext } from 'react';

export type Theme = 'dark' | 'light' | 'system';
export type ThemeProviderState = { theme: Theme; setTheme: (theme: Theme) => void };
export const initialThemeState: ThemeProviderState = { theme: 'system', setTheme: () => null };

export const ThemeProviderContext = createContext<ThemeProviderState>(initialThemeState);

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

